export const responseError = () => {
  return { error: true }
}

export const responseErrorWithMessage = async response => {
  const body = await response.json().catch(() => null)
  return { ...responseError(), message: body?.message }
}